import { createReducer } from 'redux-create-reducer';
import {
  existingInstallYearUpdateAction,
  caseTypeUpdateAction,
  existingCaseTypeUpdateAction,
  existingStateUpdateAction,
  caseNameUpdateAction,
  requestFormAction,
  receiveFormAction,
} from '../actions/form';
import { selectCustomerAction, addCustomerAction } from '../actions/customers';
import {
  selectSiteAction,
  unselectSiteAction,
  addSiteAction,
} from '../actions/sites';
import { selectContactAction } from '../actions/contacts';
import { NEW_CASE } from '../components/ExistingCaseType';

const initialState = {
  name: '',
  customerId: undefined,
  existingCaseType: NEW_CASE,
  type: undefined,
  existingState: undefined,
  existingInstallYear: undefined,
  siteId: undefined,
  contacts: [],
  contactId: undefined,
  isFetching: false,
  errors: [],
};

const ERRORS = 'errors';

export const formReducer = createReducer(initialState, {
  [existingCaseTypeUpdateAction](state, action) {
    return {
      ...state,
      existingCaseType: action.payload,
    };
  },
  [caseTypeUpdateAction](state, action) {
    return {
      ...state,
      type: action.payload,
    };
  },
  [existingInstallYearUpdateAction](state, action) {
    return {
      ...state,
      existingInstallYear: parseInt(action.payload, 10),
    };
  },
  [existingStateUpdateAction](state, action) {
    return {
      ...state,
      existingState: action.payload,
    };
  },
  [caseNameUpdateAction](state, action) {
    return {
      ...state,
      name: action.payload,
    };
  },
  [selectCustomerAction](state, action) {
    return {
      ...state,
      customerId: parseInt(action.payload, 10),
      siteId: undefined,
    };
  },
  [addCustomerAction](state, action) {
    return {
      ...state,
      customerId: parseInt(action.payload.id, 10),
    };
  },
  [requestFormAction](state) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [receiveFormAction](state, action) {
    return {
      ...action.payload,
      errors: [],
      isFetching: false,
    };
  },
  [selectSiteAction](state, action) {
    return {
      ...state,
      siteId: parseInt(action.payload.id, 10),
    };
  },
  [unselectSiteAction](state, action) {
    return {
      ...state,
      siteId: undefined,
    };
  },
  [addSiteAction](state, action) {
    return {
      ...state,
      siteId: parseInt(action.payload.id, 10),
    };
  },
  [selectContactAction](state, action) {
    const contacts = state.contacts
      .slice()
      .filter(c => c.site !== action.payload.site);
    contacts.push({
      contact: parseInt(action.payload.contact, 10),
      site: action.payload.site,
    });
    return {
      ...state,
      contacts: contacts,
      contactId: parseInt(action.payload.contact, 10),
    };
  },
  [ERRORS](state, action) {
    return {
      ...state,
      errors: action.payload,
    };
  },
});

export default formReducer;

export const getName = state => state.form.name;
export const getCaseType = state => state.form.type;
export const getExistingCaseType = state => state.form.existingCaseType;
export const getExistingInstallYear = state => state.form.existingInstallYear;
export const getExistingState = state => state.form.existingState;
export const getForm = state => state.form;
export const getSelectedSite = state => state.form.siteId;
export const getSelectedContacts = state => state.form.contacts;
export const getSelectedContact = state => state.form.contactId;
export const getCustomerId = state => state.form.customerId;
export const getErrors = state => state.form.errors;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step1/reducers/form.js